<template>
  <div class="employee">
    <CCard class="card-table-emloyee">
      <CRow>
        <CCol sm="3" >
          <div class="form-group">
            <label>{{ $t("commons.staff_id") }}</label>
            <input
              type="text"
              class="form-control"
              v-model="searchData.staff_id"
              :class="{ 'is-invalid': errors.staff_id }"
            />
            <div v-if="errors.staff_id" class="invalid-feedback">
              {{ errors.staff_id }}
            </div>
          </div>
        </CCol>
        <CCol sm="3" >
          <div class="form-group">
            <label>{{ $t("employee.label_employee_name") }}</label>
            <input
              type="text"
              class="form-control"
              v-model="searchData.staff_name"
              :class="{ 'is-invalid': errors.staff_name }"
            />
            <div v-if="errors.staff_name" class="invalid-feedback">
              {{ errors.staff_name }}
            </div>
          </div>
        </CCol>
        <CCol sm="3" >
          <div class="form-group">
            <label>{{ $t("employee.label_employee_division") }}</label>
            <select
              class="form-control"
              v-model="searchData.department_name"
              :class="{ 'is-invalid': errors.department_name }"
            >
              <option value="all" selected>All</option>
              <option 
                v-for="department in allDepartments" 
                :key="department.code"
                :value="department.name"
              >
                {{ department.name }}
              </option>
            </select>
            <div v-if="errors.department_name" class="invalid-feedback">
              {{ errors.department_name }}
            </div>
          </div>
        </CCol>
        <CCol sm="3" >
          <div class="form-group">
            <label>{{ $t("note.short_leave_request.leave_type") }}</label>
            <select
              class="form-control"
              v-model="searchData.leave_type"
              :class="{ 'is-invalid': errors.leave_type }"
            >
              <option value="">{{ $t("note.short_leave_request.choose_leave_type") }}</option>
              <option value="late">{{ $t("note.short_leave_request.leave_type_late") }}</option>
              <option value="early">{{ $t("note.short_leave_request.leave_type_early") }}</option>
            </select>
            <div v-if="errors.leave_type" class="invalid-feedback">
              {{ errors.leave_type }}
            </div>
          </div>
        </CCol>
        <CCol sm="3">
          <div class="form-group">
            <label>{{ $t("commons.label_start_date") }}</label>
            <DatePickerFormFlex
              :propsDate="searchData.start_date || ''"
              v-on:emitDate="chooseStartDate"
              :class="{ 'is-invalid': errors.start_date }"
            />
            <div v-if="errors.start_date" class="invalid-feedback">
              {{ errors.start_date }}
            </div>
          </div>
        </CCol>
        <CCol sm="3">
          <div class="form-group">
            <label>{{ $t("commons.label_end_date") }}</label>
            <DatePickerFormFlex
              :propsDate="searchData.end_date || ''"
              v-on:emitDate="chooseEndDate"
              :class="{ 'is-invalid': errors.end_date }"
            />
            <div v-if="errors.end_date" class="invalid-feedback">
              {{ errors.end_date }}
            </div>
          </div>
        </CCol>
        <!-- <CCol sm="3">
          <div class="form-group">
            <label>{{ $t("commons.start_time") }}</label>
            <TimeInput
              v-model="searchData.start_time"
              placeholder="HH:MM (VD: 09:30)"
              :hasError="!!errors.start_time"
              @blur="validateStartTime"
            />
            <div v-if="errors.start_time" class="invalid-feedback">
              {{ errors.start_time }}
            </div>
          </div>
        </CCol>
        <CCol sm="3">
          <div class="form-group">
            <label>{{ $t("commons.end_time") }}</label>
            <TimeInput
              v-model="searchData.end_time"
              placeholder="HH:MM (VD: 17:30)"
              :hasError="!!errors.end_time"
              @blur="validateEndTime"
            />
            <div v-if="errors.end_time" class="invalid-feedback">
              {{ errors.end_time }}
            </div>
          </div>
        </CCol> -->
        <CCol sm="3" >
          <div class="form-group">
            <label>{{ $t("note.short_leave_request.assigned_staff") }}</label>
            <select
              class="form-control"
              v-model="searchData.name_assign"
              :class="{ 'is-invalid': errors.name_assign }"
            >
              <option value="all" selected>All</option>
              <option 
                v-for="employee in assignableEmployees" 
                :key="employee.id"
                :value="employee.name"
              >
                {{ employee.name }}
              </option>
            </select>
            <div v-if="errors.name_assign" class="invalid-feedback">
              {{ errors.name_assign }}
            </div>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" class="btn-search text-center">
          <CButton class="btn-search-employee" @click.prevent="search" :disabled="!isFormValid">
            {{ $t("button.label_employee_btn_search") }}
          </CButton>
          <!-- <CButton class="btn-reset" @click="resetForm"
            >{{ $t("button.label_action_reset") }}
          </CButton> -->
          <!-- button export -->
          <CButton class="btn-export" @click="exportData" :disabled="!shortLeaveRequests || shortLeaveRequests.length === 0">
            {{ $t("button.label_export_excel") }}
          </CButton>
        </CCol>
      </CRow>
    </CCard>

    <CRow>
      <CCol sm="12">
        <CCard class="employee-table">
          <CCardBody>
            <div class="option-table">
              <div class="form-group">
                <select
                  class="form-control select-per-page"
                  v-model="searchData.itemsPerPage"
                  @change="search"
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </select>
              </div>
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ pagination.from }}
                {{ $t("commons.label_text_to") }}
                {{ pagination.to }}
                {{ $t("commons.label_text_of") }}
                {{ pagination.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th class="text-center">{{ $t("employee.label_employee_code") }}</th>
                    <th class="text-center" >{{ $t("employee.label_employee_name") }}</th>
                    <th class="text-center" >{{ $t("employee.label_employee_division") }}</th>
                    <th class="text-center">{{ $t("note.short_leave_request.date_leave") }}</th>
                    <th class="text-center">{{ $t("commons.start_time") }}</th>
                    <th class="text-center">{{ $t("commons.end_time") }}</th>
                    <th class="text-center">{{ $t("note.short_leave_request.time_off") }}</th>
                    <th class="text-center">{{ $t("note.short_leave_request.leave_type") }}</th>
                    <th class="text-center"  >{{ $t("note.short_leave_request.assigned_staff") }}</th>
                    <th class="text-center">{{ $t("note.short_leave_request.reason") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-if="shortLeaveRequests && shortLeaveRequests.length > 0"
                    v-for="(item, index) in shortLeaveRequests" :key="index"
                  >
                    <th scope="row">{{ (pagination.currentPage - 1) * pagination.perPage + index + 1 }}</th>
                    <td class="text-center">{{ getEmployeeId(item) }}</td>
                    <td class="text-center" >{{ getEmployeeName(item) }}</td>
                    <td class="text-center" >{{ getDepartmentName(item) }}</td>
                    <td class="text-center">{{ formatDate(item.date_leave) }}</td>
                    <td class="text-center">{{ formatTime(item.start_time) }}</td>
                    <td class="text-center">{{ formatTime(item.end_time) }}</td>
                    <td class="text-center">{{ item.leave_duration }}</td>
                    <td class="text-center">
                      <CBadge :color="item.leave_type === 'late' ? 'warning' : 'info'">
                        {{ item.leave_type === 'late' ? $t('note.short_leave_request.leave_type_late') : $t('note.short_leave_request.leave_type_early') }}
                      </CBadge>
                    </td>
                    <td class="text-center"  >
                      <div 
                        v-if="item.map_assign_short_leave_requests && item.map_assign_short_leave_requests.length > 0"
                        v-for="mapAssignShortLeaveRequest in item.map_assign_short_leave_requests"
                        :key="mapAssignShortLeaveRequest.id"
                      >
                        <span v-if="mapAssignShortLeaveRequest.account && mapAssignShortLeaveRequest.account.employee && mapAssignShortLeaveRequest.account.employee.name">
                          {{ mapAssignShortLeaveRequest.account.employee.name }}
                        </span>
                        <span v-else class="text-danger">
                          No data employee Account ID: {{ mapAssignShortLeaveRequest.account_id }}
                        </span>
                      </div>
                    </td>
                    <td class="text-center">{{ item.reason }}</td>
                  </tr>
                  <tr v-else>
                    <td colspan="11" class="text-center">
                      {{ $t("commons.label_text_no_data") }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCardBody>
          <div v-if="shortLeaveRequests && shortLeaveRequests.length > 0">
            <CPagination
              :activePage.sync="pagination.currentPage"
              :pages="pagination.totalPage"
              @update:activePage="changePage"
              size="sm"
              align="center"
            />
          </div>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import DatePickerFormFlex from "@/components/Common/DatePickerFormFlex";
import moment from "moment";
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '@/store/mutation-types';
import api from '@/api/api';
import axios from '@/plugins/axios';
import TimeInput from "@/components/Common/TimeInput";
import XLSX from "xlsx"; // Import XLSX

export default {
  name: "ShortLeaveRequestList",
  metaInfo() {
    return {
      title: this.$t("page_title.page_short_leave_request_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    DatePickerFormFlex,
    TimeInput
  },
  data() {
    return {
      searchData: {
        staff_id: "",
        staff_name: "",
        department_name: "all",
        leave_type: "",
        name_assign: "all",
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
        itemsPerPage: 10
      },
      errors: {
        staff_id: "",
        staff_name: "",
        department_name: "",
        leave_type: "",
        name_assign: "",
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: ""
      },
      export: true // Flag để export
    };
  },
  computed: {
    ...mapGetters({
      shortLeaveRequests: 'shortLeaveRequest/shortLeaveRequests',
      pagination: 'shortLeaveRequest/pagination',
      shortLeaveRequestsExport: 'shortLeaveRequest/shortLeaveRequestsExport',
      foots: 'commons/foots',
      divisions: 'commons/divisions',
      assignableEmployees: 'shortLeaveRequest/assignableEmployees'
    }),
    
    allDepartments() {
      return [
        ...this.foots,
        ...this.divisions
      ].sort((a, b) => a.name.localeCompare(b.name));
    },
    
    isFormValid() {
      return !this.errors.staff_id && 
             !this.errors.staff_name &&
             !this.errors.department_name &&
             !this.errors.leave_type &&
             !this.errors.name_assign &&
             !this.errors.start_date && 
             !this.errors.end_date && 
             !this.errors.start_time && 
             !this.errors.end_time;
    },
  },
  methods: {
    ...mapActions({
      listShortLeaveRequests: 'shortLeaveRequest/listShortLeaveRequests',
      listShortLeaveRequestsAssign: 'shortLeaveRequest/listShortLeaveRequestsAssign',
      setLoading: 'layout/setLoading',
      listShortLeaveRequestsExport: 'shortLeaveRequest/listShortLeaveRequestsExport',
      getCommonsData: 'commons/getCommonsData',
      loadAssignableEmployees: 'shortLeaveRequest/loadAssignableEmployees'
    }),
    ...mapMutations({
      setPagination: `shortLeaveRequest/${types.SHORT_LEAVE_REQUEST.SET_PAGINATION}`
    }),
    getEmployeeId(item) {
      return item.account && item.account.employee ? item.account.employee.id : '-';
    },
    
    getEmployeeName(item) {
      return item.account && item.account.employee ? item.account.employee.name : '-';
    },
    
    getDepartmentName(item) {
      return item.account && item.account.employee && item.account.employee.department 
        ? item.account.employee.department.name 
        : '-';
    },
    chooseStartDate(data) {
      this.searchData.start_date = data;
      this.validateStartDate();
    },
    chooseEndDate(data) {
      this.searchData.end_date = data;
      this.validateEndDate();
    },
    validateStaffId() {
      this.errors.staff_id = "";
      if (this.searchData.staff_id && this.searchData.staff_id.length > 255) {
        this.errors.staff_id = "Mã nhân viên không được vượt quá 255 ký tự";
      }
    },
    validateStaffName() {
      this.errors.staff_name = "";
      if (this.searchData.staff_name && this.searchData.staff_name.length > 255) {
        this.errors.staff_name = "Tên nhân viên không được vượt quá 255 ký tự";
      }
    },
    validateDepartmentName() {
      this.errors.department_name = "";
      if (this.searchData.department_name && this.searchData.department_name.length > 255) {
        this.errors.department_name = "Tên phòng ban không được vượt quá 255 ký tự";
      }
    },
    validateLeaveType() {
      this.errors.leave_type = "";
      if (this.searchData.leave_type && this.searchData.leave_type.length > 255) {
        this.errors.leave_type = "Loại nghỉ không được vượt quá 255 ký tự";
      }
    },
    validateNameAssign() {
      this.errors.name_assign = "";
      if (this.searchData.name_assign && this.searchData.name_assign.length > 255) {
        this.errors.name_assign = "Tên người phê duyệt không được vượt quá 255 ký tự";
      }
      if (this.searchData.leave_type !== 'late' && this.searchData.leave_type !== 'early' && this.searchData.leave_type !== '') {
        this.errors.leave_type = "Loại nghỉ không hợp lệ";
      }
    },
    validateStartDate() {
      this.errors.start_date = "";
      if (this.searchData.start_date) {
        const date = moment(this.searchData.start_date, 'DD/MM/YYYY');
        if (!date.isValid()) {
          this.errors.start_date = "Ngày không hợp lệ";
        }
      }
    },
    validateEndDate() {
      this.errors.end_date = "";
      if (this.searchData.end_date) {
        const date = moment(this.searchData.end_date, 'DD/MM/YYYY');
        if (!date.isValid()) {
          this.errors.end_date = "Ngày không hợp lệ";
        }
      }
      if (this.searchData.end_date && this.searchData.start_date) {
        if (this.searchData.end_date < this.searchData.start_date) {
          this.errors.end_date = "Ngày kết thúc phải lớn hơn hoặc bằng ngày bắt đầu";
        }
      }
    },
    validateStartTime() {
      this.errors.start_time = "";
      if (this.searchData.start_time) {
        const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
        if (!timeRegex.test(this.searchData.start_time)) {
          this.errors.start_time = "Thời gian phải có định dạng HH:MM (VD: 09:30)";
        }
      }
      this.validateTimeRange();
    },
    validateEndTime() {
      this.errors.end_time = "";
      if (this.searchData.end_time) {
        const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
        if (!timeRegex.test(this.searchData.end_time)) {
          this.errors.end_time = "Thời gian phải có định dạng HH:MM (VD: 17:30)";
        }
      }
      this.validateTimeRange();
    },
    validateTimeRange() {
      if (this.searchData.start_time && this.searchData.end_time && !this.errors.start_time && !this.errors.end_time) {
        const startTime = moment(this.searchData.start_time, 'HH:mm');
        const endTime = moment(this.searchData.end_time, 'HH:mm');
        
        if (endTime.isSameOrBefore(startTime)) {
          this.errors.end_time = "Thời gian kết thúc phải sau thời gian bắt đầu";
        }
      }
    },
    clearErrors() {
      this.errors = {
        staff_id: "",
        choose_date: "",
        start_time: "",
        end_time: ""
      };
    },
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    formatTime(time) {
      if (!time) return '';
      return moment(time).format('HH:mm');
    },
    async fetchData() {
      this.setLoading(true);
      try {
        const params = {
          per_page: this.searchData.itemsPerPage,
          current_page: this.pagination.currentPage
        };
        if (this.searchData.staff_id) {
          params.staff_id = this.searchData.staff_id;
        }
        if (this.searchData.staff_name) {
          params.staff_name = this.searchData.staff_name;
        }
        if (this.searchData.department_name) {
          params.department_name = this.searchData.department_name;
        }
        if (this.searchData.leave_type) {
          params.leave_type = this.searchData.leave_type;
        }
        if (this.searchData.name_assign) {
          params.name_assign = this.searchData.name_assign;
        }
        if (this.searchData.start_date) {
          params.start_date = this.searchData.start_date ? moment(this.searchData.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : this.searchData.start_date;
        }
        if (this.searchData.end_date) {
          params.end_date = this.searchData.end_date ? moment(this.searchData.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : this.searchData.end_date;
        }
        if (this.searchData.start_time) {
          params.start_time = this.searchData.start_time;
        }
        if (this.searchData.end_time) {
          params.end_time = this.searchData.end_time;
        }
        await this.listShortLeaveRequests(params);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.setLoading(false);
      }
    },
    async search() {
      // Validate all fields before search
      this.validateStaffId();
      this.validateStaffName();
      this.validateDepartmentName();
      this.validateLeaveType();
      this.validateNameAssign();
      this.validateStartDate();
      this.validateEndDate();
      this.validateStartTime();
      this.validateEndTime();
      
      if (this.isFormValid) {
        this.setPagination({
          ...this.pagination,
          currentPage: 1
        });
        await this.fetchData();
      }
    },
    async resetForm() {
      this.searchData.staff_id = "";
      this.searchData.staff_name = "";
      this.searchData.department_name = "";
      this.searchData.leave_type = "";
      this.searchData.name_assign = "";
      this.searchData.start_date = "";
      this.searchData.end_date = "";
      this.searchData.start_time = "";
      this.searchData.end_time = "";
      this.clearErrors();
      this.setPagination({
        ...this.pagination,
        currentPage: 1
      });
      await this.fetchData();
    },
    async changePage(page) {
      this.setPagination({
        ...this.pagination,
        currentPage: page
      });
      await this.fetchData();
    },
    async exportData() {
      this.setLoading(true);
      try {
        await this.listShortLeaveRequestsExport({
          staff_id: this.searchData.staff_id,
          staff_name: this.searchData.staff_name,
          start_date: this.searchData.start_date ? moment(this.searchData.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : this.searchData.start_date,
          end_date: this.searchData.end_date ? moment(this.searchData.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : this.searchData.end_date,
          department_name: this.searchData.department_name,
          leave_type: this.searchData.leave_type,
          name_assign: this.searchData.name_assign,
          start_time: this.searchData.start_time,
          end_time: this.searchData.end_time,
          sort_column: this.searchData.sort_column,
          sort_by: this.searchData.sort_by
        });

        // Tạo heading cho Excel
        let Heading = [
          [
            "STT",
            "Mã nhân viên",
            "Họ và tên",
            "Bộ phận",
            "Ngày request",
            "Thời gian bắt đầu",
            "Thời gian kết thúc",
            "Thời gian nghỉ",
            "Loại nghỉ",
            "Nhân sự assign",
            "Lý do"
          ]
        ];

        // Tạo worksheet
        var ws = XLSX.utils.aoa_to_sheet(Heading);

        // Chuẩn bị dữ liệu export
        let dataExport = this.shortLeaveRequestsExport.map((item, index) => {
          return [
            index + 1,
            this.getEmployeeId(item),
            this.getEmployeeName(item),
            this.getDepartmentName(item),
            this.formatDate(item.date_leave),
            this.formatTime(item.start_time),
            this.formatTime(item.end_time),
            item.leave_duration,
            item.leave_type === 'late' ? 'Đi muộn' : 'Về sớm',
            this.getAssignedStaffNames(item),
            item.reason
          ];
        });

        // Thêm dữ liệu vào worksheet
        ws = XLSX.utils.sheet_add_json(ws, dataExport, {
          skipHeader: true,
          origin: "A2"
        });

        // Thêm border cho tất cả cells
        const range = XLSX.utils.decode_range(ws['!ref']);
        
        // Style cho border
        const borderStyle = {
          style: 'thin',
          color: { rgb: '000000' }
        };

        // Áp dụng style cho từng cell
        for (let R = range.s.r; R <= range.e.r; R++) {
          for (let C = range.s.c; C <= range.e.c; C++) {
            const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
            
            if (!ws[cellAddress]) {
              ws[cellAddress] = { v: '' };
            }

            // Thêm border cho tất cả cells
            ws[cellAddress].s = {
              border: {
                top: borderStyle,
                bottom: borderStyle,
                left: borderStyle,
                right: borderStyle
              }
            };
          }
        }

        // Auto-fit column width
        const columnWidths = [
          { wch: 5 },   // STT
          { wch: 12 },  // Mã nhân viên
          { wch: 20 },  // Họ và tên
          { wch: 15 },  // Bộ phận
          { wch: 12 },  // Ngày nghỉ
          { wch: 15 },  // Thời gian bắt đầu
          { wch: 15 },  // Thời gian kết thúc
          { wch: 12 },  // Thời gian nghỉ
          { wch: 10 },  // Loại nghỉ
          { wch: 20 },  // Nhân sự assign
          { wch: 30 }   // Lý do
        ];

        ws['!cols'] = columnWidths;

        // Tạo workbook và download
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Danh sách đơn đi muộn về sớm");

        const now = moment();
        const timeStr = now.format('HHmmss');
        const dateStr = now.format('YYYYMMDD');
        const fileName = `danh_sach_don_di_muon_ve_som_${dateStr}_${timeStr}.xlsx`;

        XLSX.writeFile(wb, fileName);

        this.setLoading(false);
        this.$toast(
          this.$t("popup.label_popup_export_success"),
          null,
          2000,
          "b-toaster-top-center",
          "success"
        );
      } catch (error) {
        this.setLoading(false);
        this.$toast(
          this.$t("popup.label_popup_export_error"),
          null,
          2000,
          "b-toaster-top-center",
          "error"
        );
      }
    },

    // Helper method để lấy tên nhân viên được giao
    getAssignedStaffNames(item) {
      if (item.map_assign_short_leave_requests && item.map_assign_short_leave_requests.length > 0) {
        return item.map_assign_short_leave_requests
          .map(mapAssign => {
            if (mapAssign.account && mapAssign.account.employee && mapAssign.account.employee.name) {
              return mapAssign.account.employee.name;
            }
            return '';
          })
          .filter(name => name !== '')
          .join(', ');
      }
      return '';
    },
  },
  
  watch: {
    'searchData.staff_id'() {
      this.validateStaffId();
    }
  },
  
  async mounted() {
    try {
      await this.getCommonsData();
      await this.loadAssignableEmployees();
      await this.fetchData();
    } catch (error) {
      console.error('Error in mounted:', error);
    }
  }
}
</script>

<style lang="scss" scoped>
.employee {
  margin: -2rem -30px 30px -30px;
  .card-table-emloyee {
    padding: 30px;
  }
  .btn-search-employee {
    background-color: #b5dbf2;
    padding: 8px;
    width: 120px;
    &:disabled {
      background-color: #ccc;
      cursor: not-allowed;
    }
  }
  .employee-table {
    margin: 0 20px 0 30px;
  }
  .select-per-page {
    width: 70px;
  }
  .option-table {
    display: flex;
    justify-content: space-between;
  }
  .btn-search {
    margin-top: 15px;
  }
  .btn-reset {
    background: #e8e5e5;
    padding: 8px;
    width: 120px;
  }
  th,
  td {
    vertical-align: middle !important;
  }
  
  .is-invalid {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
  }
  
  .invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
  }

  .btn-create {
    background-color: #3c4b64;
    color: white;
    padding: 8px;
    width: 120px;
    margin-left: 10px;
    border: none;
    
    &:hover {
      background-color: #44536b;
    }
  }
  .btn-tab-group {
    width: 30%;
    margin-top: 1.5rem;
    .btn-tab {
      background-color: transparent;
      color: #3c4b64;
      border: 1px solid #3c4b64 !important;
      padding: 8px;
      border: none;
      padding: 5px;
      transition: all 0.3s ease;
      
      &:hover {
        background-color: #44536b;
        color: white;
      }
      &.active {
        background-color: #3c4b64;
        color: white;
      }
    }
  }
  .btn-edit-svg {
    background-color: transparent;
    color: white;
    padding: 0;
    width: fit-content;
    border: none;
    transition: all 0.3s ease;

    &:hover {
      scale: 1.1;
    }
    &:focus {
      outline: none !important;
      box-shadow: none !important;
    }

    svg {
      width: 20px;
    }
  }
  .btn-disabled {
    opacity: 0.5;
    cursor: default;
    &:hover {
      scale: 1;
    }
  }
  
  .select2-container--default .select2-search--inline .select2-search__field {
    width: 100% !important;
  }
  
  .is-invalid .select2-selection {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
  }
}

.btn-export {
  background-color: #3c4b64;
  border-color: #3c4b64;
  color: white;
  margin-left: 10px;
}

.btn-export:hover {
  background-color: #44536b;
  border-color: #44536b;
}

.btn-export:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
}
</style>